import { render } from "./LaboratoryPage.vue?vue&type=template&id=039e9694&scoped=true"
import script from "./LaboratoryPage.vue?vue&type=script&lang=js"
export * from "./LaboratoryPage.vue?vue&type=script&lang=js"

import "./LaboratoryPage.vue?vue&type=style&index=0&id=039e9694&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/prodbqwjw/sy-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039e9694"]])

export default __exports__